module.exports = __webpack_public_path__ + "img/puzzle.2b2b5a6f.svg";